export default __webpack_public_path__ + "static/media/visitor-centre.c9c02245.svg";